<template>
  <div class="index">
    <div class="main">
      <div class="left">
        <div>
          <h1 class="logo">浙江云端时代科技有限公司</h1>
          <p>ZHEJIANG YUNDUAN ERA OF TECHNOLOGY CO,.LTD</p>
        </div>
      </div>

      <ul class="tiaozhuan">
        <li class="li1">
          <router-link to="/" @click="ondianji(0)">首页</router-link>
          <ul>
            <li><router-link to="/#introduce">公司简介</router-link></li>
            <li><router-link to="/#architecture">业务框架</router-link></li>
            <li><router-link to="/#design"> 创新设计</router-link></li>
            <li><router-link to="/#process">发展历程</router-link></li>
            <li><router-link to="/#location"> 办公地点</router-link></li>
          </ul>
        </li>
        <li class="li1">
          <router-link to="/conscientious" @click="ondianji(1)"
            >主营业务</router-link
          >
          <ul>
            <li>
              <router-link to="/conscientious#yewu">业务范围</router-link>
            </li>
            <li>
              <router-link to="/conscientious#cangchu">仓储优势</router-link>
            </li>
            <li>
              <router-link to="/conscientious#pinpai"> 自主品牌</router-link>
            </li>
          </ul>
        </li>
        <li class="li1">
          <router-link to="/honor" @click="ondianji(2)">公司荣誉</router-link>
        </li>

        <li class="li1">
          <router-link to="/join" @click="ondianji(3)">加入我们</router-link>
          <ul>
            <li><router-link to="/join#philosophy">用人理念</router-link></li>
            <li><router-link to="/join#innovation">创新</router-link></li>
            <li>
              <router-link to="/join#compensarion"> 薪酬福利</router-link>
            </li>
            <li><router-link to="/join#telent">人才招聘</router-link></li>
            <li><router-link to="/join#map"> 导航地图</router-link></li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <div style="height: 80px" id="box"></div>

  <router-view />
  <div class="bottom">
    <div class="center">
      <div class="top">
        <div class="yunduan">
          <div>浙江云端时代科技有限公司</div>
          <p>ZHEJIANG YUNDUAN ERA OF TECHNOLOGY CO,.LTD</p>
        </div>
        <div id="cloudstyle">
          <p>联系我们</p>
          <div>招聘相关 hr@cloudstyle.com</div>
          <div>商务合作 Steven@cloudstyle.com</div>
        </div>
        <div class="right1">
          <p>想了解更多咨询和动态，关注我们</p>
          <div>
            <img src="../src/img/weixin.png" alt="" />
            <img src="../src/img/in.png" alt="" />
          </div>
        </div>
      </div>

      <div class="bot">
        <p>版权声明 © 2017 - 2023 浙江云端时代科技有限公司 版权所有</p>
        <p>公示信息：浙ICP备18034741号</p>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useRouter } from "vue-router";
import { onMounted, onUnmounted } from "vue";

const router = useRouter();
var width = document.querySelector("html").offsetWidth;

const test = () => {
  var rightcli = document.getElementById("imgcli");
  var tuozhuan = document.querySelector(".tiaozhuan");
  var right1 = document.querySelector(".right1");
  if (width <= 960) {
    rightcli.style.display = "none";
    tuozhuan.style.opacity = 1;
    right1.style.display = "block";
    tuozhuan.style.transition = " all 0.4s ease-in-out";
  }
};
const test1 = () => {
  var rightcli = document.getElementById("imgcli");
  var tuozhuan = document.querySelector(".tiaozhuan");
  var right1 = document.querySelector(".right1");
  if (width <= 960) {
    tuozhuan.style.opacity = 0;
    // transition: all 0.25s ease-in-out;
    tuozhuan.style.transition = " all 0.4s ease-in-out";
    right1.style.display = "none";
    rightcli.style.display = "block";
  }
};
const ondianji = (e) => {
  localStorage.setItem("key", e);
  var li = document.querySelectorAll(".li1");
  for (let i = 0; i < li.length; i++) {
    const element = li[i];
    if (e == i) {
      element.classList.add("active");
    } else {
      element.classList.remove("active");
    }
  }
};
onMounted(() => {
  const e = localStorage.getItem("key");
  var li = document.querySelectorAll(".li1");
  for (let i = 0; i < li.length; i++) {
    const element = li[i];
    if (e == i) {
      element.classList.add("active");
    } else {
      element.classList.remove("active");
    }
  }
});

const routerHook = (e) => {};
</script>
<style lang="scss">
* {
  user-select: none;
}
* {
  font-family: "siyuan" !important;
}
body {
  margin: 0;
}
@media screen and (min-width: 960px) {
  .index {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 80px;
    background-color: #ffffff;
    z-index: 100;
  }
  .example-showcase .el-dropdown-link {
    cursor: pointer;
    color: var(--el-color-primary);
    display: flex;
    align-items: center;
  }
  .active {
    // background-color: #254461;
    a {
      color: #254461 !important;
    }
  }
  .main {
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1400px;
    margin: 0 auto;

    .tiaozhuan {
      display: flex;
      // background-color: pink;
      width: 600px;
      justify-content: space-between;

      .li1 {
        list-style: none;
        width: 24%;
        position: relative;
        > a {
          text-decoration: none;
          outline: none;
          color: #000;
          font-size: 20px;
          font-weight: 700;
        }

        > a:hover {
          // border-bottom: 2px solid salmon;
          color: #254461;
        }
        > ul {
          width: 90%;
          display: none !important;
          position: absolute;
          top: 20px;
          left: 0;
          display: flex;
          padding: 10px;
          flex-direction: column;
          background-color: #ffffff;
          > li {
            line-height: 36px;
            a {
              text-decoration: none;
              color: #000 !important;
            }
            a:hover {
              text-decoration: none;
              color: #254461 !important;
            }
          }
        }
      }
      > .li1:hover {
        ul {
          display: block !important;
        }
      }
    }

    .left {
      display: flex;

      .logo {
        font-size: 30px;
        color: #254461;
        font-weight: 600;
        margin-top: 6px;
      }

      #right {
        display: none;
      }

      p {
        margin-top: 8px;
        font-size: 14px;
      }
    }
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }

  .bottom {
    // background: url(./img/bottom.jpg);
    background-color: #000;
    height: 348px;

    .center {
      width: 1300px;
      margin: 0 auto;
      text-align: center;

      .top {
        height: 270px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        > .yunduan {
          border-right: 1px solid #818181;
          padding: 40px;
          text-align: left;
          > div {
            font-size: 34px;
            color: #ffffff;
          }
          > p {
            color: #818181;
            margin-top: 6px;
          }
        }
        > #cloudstyle {
          text-align: left;
          padding: 40px;
          border-right: 1px solid #818181;
          width: 26%;
          p {
            line-height: 40px;
            color: #818181;
            font-size: 18px;
          }
          > div {
            color: #ffffff;
            line-height: 30px;
          }
        }
        > .right1 {
          text-align: left;
          padding-left: 20px;
          p {
            line-height: 50px;
            color: #818181;
            font-size: 18px;
          }
          div {
            width: 200px;
            img:nth-child(2) {
              margin-left: 40px;
            }
          }
        }
      }

      .bot {
        p {
          color: #9d9d9d;
        }

        height: 18px;

        p:nth-child(1) {
          margin-top: 10px;
        }

        p:nth-child(2) {
          margin-top: 24px;
        }
      }
    }
  }
}
@media screen and (max-width: 960px) {
  #box {
    display: none;
  }
  .index {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 40px;
    background-color: #ffffff;
    z-index: 100;
    border-bottom: 1px solid #d4deee;
  }
  .main {
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 360px;
    margin: 0 auto;
    font-size: 12px;
    color: #000;
    .left {
      p {
        display: none;
      }
    }
    .tiaozhuan {
      display: flex;
      font-size: 12px;
      // background-color: pink;
      width: 190px;
      justify-content: space-between;
      .li1 {
        list-style: none;
        > a {
          text-decoration: none;
          color: #000;
        }
        > a:hover {
          // border-bottom: 2px solid salmon;
          color: #254461;
        }
        ul {
          display: none;
        }
      }
    }
  }

  .bottom {
    background-color: #000;
    font-size: 12px;
    .center {
      // width: 220px;
      height: 220px;
      // margin: 0 auto;
      text-align: center;
      .top {
        height: 180px;
        display: flex;
        // justify-content: space-between;
        align-items: center;
        > .yunduan {
          // border-right: 1px solid #818181;
          padding-left: 20px;
          text-align: left;
          width: 170px;
          > div {
            color: #ffffff;
            line-height: 20px;
          }
          > p {
            color: #818181;
            font-size: 12px;
            transform: scale(0.833); /* 缩放比例：10/12 */
            transform-origin: 0 0; /* 确保左上角对齐 */
            // white-space: nowrap; /* 防止换行 */
          }
        }
        > #cloudstyle {
          text-align: left;
          padding: 20px;
          border-left: 1px solid #818181;
          width: 33%;
          p {
            line-height: 30px;
            color: #818181;
            font-size: 16px;
          }
          > div {
            color: #ffffff;
            line-height: 20px;
          }
        }
        > .right1 {
          display: none;
        }
      }

      .bot {
        p {
          color: #9d9d9d;
        }

        height: 18px;

        p:nth-child(2) {
          margin-top: 10px;
        }
      }
    }
  }
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
main,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

* {
  font-family: "SourceHanSans";
}
</style>
